import { Action, createReducer, on } from '@ngrx/store';
import { getProductDetailsAction, getProductDetailsErrorAction, getProductDetailsSuccessAction } from './select-product.actions';
import { SelectProductState } from './select-product.state';

const initialState = new SelectProductState();

const reducer = createReducer(
  initialState,
  on(getProductDetailsAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(getProductDetailsSuccessAction, (state) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = null;
    return newState;
  }),
  on(getProductDetailsErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  })
);

export function selectProductReducer(state: SelectProductState | null, action: Action) {
  return reducer(state, action);
}
